import React from 'react';

const Space=(props)=>{
    return(
        <div style={{height:props.hig,width:'100%',backgroundColor:props.color}}></div>
    )
}

export default Space